// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  query getUser($_id: ID!) {
    getUser: getUserById(_id: $_id) {
      _id
      emails {
        address
        verified
      }
      roles
      invite
      organization {
        _id
        title
        createdAt
      }
      organizations {
        _id
        title
        createdAt
      }
      location
      directLine
      mobileNumber
      industry
      role
      dashboards {
        _id
        name
        icon
      }
      createdAt
      profile {
        firstName
        lastName
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Queries/getUser.js